var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1508_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 11.4833L10.9833 40.5H8.33333C6.63333 40.5 5.05 39.9833 3.73333 39.1167L38.6167 4.23333C39.4833 5.55 40 7.13333 40 8.83333V11.4833ZM0 24.8167L24.3167 0.5H15.7L0 16.1833V24.8V24.8167ZM40 16.2L15.6833 40.5167H24.3L39.9833 24.8333V16.2167L40 16.2ZM31.6667 0.5H29.0167L0 29.5167V32.1667C0 33.8667 0.516667 35.45 1.38333 36.7667L36.2667 1.88333C34.95 1.01667 33.3667 0.5 31.6667 0.5ZM10.9833 0.5H8.33333C3.73333 0.5 0 4.23333 0 8.83333V11.4833L10.9833 0.5ZM29.0333 40.5H31.6833C36.2833 40.5 40.0167 36.7667 40.0167 32.1667V29.5167L29.0333 40.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1508_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBackground);
export default __webpack_public_path__ + "static/media/removeBackground.5b814d7ede8d7463ae242536a00dcb9c.svg";
export { ForwardRef as ReactComponent };